import { render, staticRenderFns } from "./WorkflowFormSubmissionField.vue?vue&type=template&id=794a005f&"
import script from "./WorkflowFormSubmissionField.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports